<template>
  <div class="wrapper">
    <b-container fluid>
      <b-row>
        <b-col sm="5" lg="5">
          <Finder />
          <b-button @click="addQ" class="float-right">문제등록</b-button>
          <BookInfo />
          <QuestionList />
        </b-col>
        <b-col sm="7" lg="7">
          <QuestionForm v-if="mode == 'form'" />
          <QuestionPreview v-if="mode == 'preview2'" />
          <QPreview v-if="mode == 'preview'" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Finder from "@/components/question/Finder";
import BookInfo from "@/components/book/BookInfo";
import QuestionList from "@/components/question/list";
import QuestionForm from "@/components/question/FormV2";
import QuestionPreview from "@/components/question/QuestionPreview";
import QPreview from "@/components/question/QPreview";
export default {
  components: {
    Finder,
    BookInfo,
    QuestionList,
    QuestionForm,
    QuestionPreview,
    QPreview,
  },
  mounted() {
    let book_id = this.$route.query.book_id;
    // alert(book_id);
    this.$store.commit("updateBookID", book_id);
    this.$store.dispatch("loadBookbyId", book_id);
    this.$store.dispatch("loadQuestionList", book_id);
    this.$store.dispatch("getNextSerial");
  },
  computed: {
    mode() {
      return this.$store.state.mode;
    },
  },
  methods: {
    addQ() {
      // this.$store.commit("resetQuestionMeta");
      // this.$store.commit("resetQuestionForm");
      // this.$store.commit("resetvalid");
      // this.$store.state.questionform.q_type = "1";
      // this.$store.state.qforms = [];
      // this.$store.dispatch("getNextSerial");
      // this.$store.state.mode = "form";

      this.$store.dispatch("ResetForReady");

      // this.$store.dispatch("updateJimun", "");
    },
  },
};
</script>


<style lang="scss" scoped>
.wrapper {
  padding-top: 10px;
  //   padding-bottom: 25px;
}
.bigcont {
  display: flex;
  width: 100vw;
  min-height: calc(100vh - 180px);
  //   background-color: red;

  div:nth-child(1) {
    width: 48%;
  }
  div:nth-child(2) {
    width: 5px;
    background-color: darkgray;
    position: relative;
  }
  div:nth-child(3) {
    width: auto;
    padding-left: 10px;
  }
}
</style>